import { render, staticRenderFns } from "./ReserveMarkingModal.vue?vue&type=template&id=b608b2a4&scoped=true"
import script from "./ReserveMarkingModal.vue?vue&type=script&lang=js"
export * from "./ReserveMarkingModal.vue?vue&type=script&lang=js"
import style0 from "./ReserveMarkingModal.vue?vue&type=style&index=0&id=b608b2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608b2a4",
  null
  
)

export default component.exports